class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    this.hiddenCashOnDelivery();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("cart-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  hiddenCashOnDelivery() {
    //ミニカーとの中の代引き手数料を非表示にする
    let metafields = JMO.jmo_cashOnDelivery_metafields ? JSON.parse(JMO.jmo_cashOnDelivery_metafields || "[]") : [];
    for (let i = 0; i < metafields.length; i++) {
      let variantId = metafields[i].variantId.replace(
        "gid://shopify/ProductVariant/",
        ""
      );
      let variant = document.querySelector(
        `cart-remove-button[data-variant-id="${variantId}"]`
      );
      if (variant) {
        variant.closest("li").style.display = "none";
      }
    }
  }
}
customElements.define("cart-recommendations", CartRecommendations);
